import { createFileRoute } from '@tanstack/react-router';
import { useActiveOrganizationId } from '@interxfi/api-client';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { useCanActAsOrganizationAdmin } from '../../../../../../features/userauth/organization/userauth-organization-permission-helpers';
import { UserauthCreateRoleDrawer } from '../../../../../../features/userauth/role/userauth-create-role-drawer';
import { UserauthRolesTable } from '../../../../../../features/userauth/role/userauth-roles-table';
import { getPageHead } from '../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_platform/_context-required/role/_role/')({
  head: () => getPageHead('Roles'),
  component: RolesList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const activeOrganizationId = useActiveOrganizationId();
  const canActAsAdmin = useCanActAsOrganizationAdmin(activeOrganizationId);

  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      {canActAsAdmin ? (
        <RequiresAccess write>
          <UserauthCreateRoleDrawer
            organizationId={activeOrganizationId}
            trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="Create a role" size="small" variant="primary" />}
          />
        </RequiresAccess>
      ) : null}

      {filter}
    </HorizontalStack>
  );
}

function RolesList() {
  const activeOrganizationId = useActiveOrganizationId();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <UserauthRolesTable HeaderActions={TableHeader} organizationId={activeOrganizationId} />
      </PageLayout.Section>
    </PageLayout>
  );
}
